/**
 * @generated SignedSource<<1dccff7ab4c67fc2f6b0a2d36e133a3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingsPanelLastSyncedQuery$variables = {};
export type MeetingsPanelLastSyncedQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"MeetingsPanel_viewer">;
  };
};
export type MeetingsPanelLastSyncedQuery = {
  response: MeetingsPanelLastSyncedQuery$data;
  variables: MeetingsPanelLastSyncedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostUnit",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCostAvgSalary",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingAttendeesEnabled",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxRecommendedAttendees",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attendeeWeeklyMeetingHoursWarningEnabled",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attendeeWeeklyMeetingHoursLimit",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noMeetingDaysEnabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noMeetingDay",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortNoticeEnabled",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortNoticeNumHours",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finiteRecurringMeetingsEnabled",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breaksBetweenMeetingsEnabled",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breaksBetweenMeetingsBehaviour",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptWhenSavingEnabled",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptWhenSavingGuidelinesUrl",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeZone",
  "kind": "LinkedField",
  "name": "timezone",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userLabel",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingsPanelLastSyncedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MeetingsPanel_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MeetingsPanelLastSyncedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uxSimplificationEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "calendarServiceToReconnect",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DismissedElement",
            "kind": "LinkedField",
            "name": "dismissedElements",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToCopilot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarConnection",
            "kind": "LinkedField",
            "name": "calendars",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CalendarEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Calendar",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "source",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sourcePrimary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncEnabled",
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastSyncDatetime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hadErrorOnSync",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToScheduledMeetingRecordings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remainingMeetingRecordingCredits",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPersonalType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailDomainList",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "primaryAdmin",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullName",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountRecordingCredits",
                "kind": "LinkedField",
                "name": "recordingCredits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedAiMeetingCredits",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSubscriptionActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionState",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionBillingCycleAnchor",
                    "storageKey": null
                  },
                  (v0/*: any*/),
                  {
                    "alias": "hasAccessToMeetingGuidelines",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "meeting_guidelines"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_guidelines\")"
                  },
                  {
                    "alias": "hasAccessToMeetingCost",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "meeting_cost"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_cost\")"
                  },
                  {
                    "alias": "hasAccessToMeetingRecorderFeature",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "meeting_recorder"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_recorder\")"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ExtensionSettings",
                "kind": "LinkedField",
                "name": "extensionSettings",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCostEnforceWorkspaceSettings",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateConfigured",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserEventFiltersNode",
                "kind": "LinkedField",
                "name": "eventFilters",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeCancelled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeHidden",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeDeclined",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeAllDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeOutOfOffice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeFocusTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includePersonalMeetings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "filterKeywords",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAutoRecordSettings",
            "kind": "LinkedField",
            "name": "autoRecordSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meetingOwnershipFilter",
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultConferenceProvider",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZoomUserNode",
                "kind": "LinkedField",
                "name": "zoom",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasMeetingWriteScope",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserSettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TimezonePreferences",
                "kind": "LinkedField",
                "name": "timezonePreferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTimezone",
                    "kind": "LinkedField",
                    "name": "preferredTimezone",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTimezone",
                    "kind": "LinkedField",
                    "name": "extraTimezones",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAdminAccess",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingGuidelines",
            "kind": "LinkedField",
            "name": "meetingGuidelines",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8b70cd777bddbfd24a05a6c1ae212c7c",
    "id": null,
    "metadata": {},
    "name": "MeetingsPanelLastSyncedQuery",
    "operationKind": "query",
    "text": "query MeetingsPanelLastSyncedQuery {\n  viewer {\n    ...MeetingsPanel_viewer\n    id\n  }\n}\n\nfragment DatePickerAgenda_viewer on Viewer {\n  calendars {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment EventFilters_viewer on Viewer {\n  user {\n    internalAttributes {\n      dateConfigured\n      id\n    }\n    eventFilters {\n      includeCancelled\n      includeHidden\n      includeDeclined\n      includeAllDay\n      includeOutOfOffice\n      includeFocusTime\n      includePersonalMeetings\n      filterKeywords\n      id\n    }\n    id\n  }\n  calendars {\n    edges {\n      node {\n        source\n        id\n      }\n    }\n  }\n}\n\nfragment EventFormModal_viewer on Viewer {\n  hasAccessToScheduledMeetingRecordings\n  ...EventForm_viewer\n  ...usePreferredTimezone_viewer\n  ...WeekPreview_viewer\n  remainingMeetingRecordingCredits\n  account {\n    extensionSettings {\n      meetingCostEnabled\n      meetingCostEnforceWorkspaceSettings\n      meetingCostUnit\n      meetingCostAvgSalary\n      meetingAttendeesEnabled\n      maxRecommendedAttendees\n      attendeeWeeklyMeetingHoursWarningEnabled\n      attendeeWeeklyMeetingHoursLimit\n      noMeetingDaysEnabled\n      noMeetingDay\n      shortNoticeEnabled\n      shortNoticeNumHours\n      finiteRecurringMeetingsEnabled\n      breaksBetweenMeetingsEnabled\n      breaksBetweenMeetingsBehaviour\n      promptWhenSavingEnabled\n      promptWhenSavingGuidelinesUrl\n      id\n    }\n    billingAccount {\n      hasAccessToMeetingGuidelines: hasAccessToFeature(feature: meeting_guidelines)\n      hasAccessToMeetingCost: hasAccessToFeature(feature: meeting_cost)\n      hasAccessToMeetingRecorderFeature: hasAccessToFeature(feature: meeting_recorder)\n      id\n    }\n    id\n  }\n  meetingGuidelines {\n    meetingCostEnabled\n    meetingCostUnit\n    meetingCostAvgSalary\n    meetingAttendeesEnabled\n    maxRecommendedAttendees\n    attendeeWeeklyMeetingHoursWarningEnabled\n    attendeeWeeklyMeetingHoursLimit\n    noMeetingDaysEnabled\n    noMeetingDay\n    shortNoticeEnabled\n    shortNoticeNumHours\n    finiteRecurringMeetingsEnabled\n    breaksBetweenMeetingsEnabled\n    breaksBetweenMeetingsBehaviour\n    promptWhenSavingEnabled\n    promptWhenSavingGuidelinesUrl\n  }\n  settings {\n    timezonePreferences {\n      preferredTimezone {\n        timezone {\n          name\n        }\n        userLabel\n      }\n      extraTimezones {\n        timezone {\n          name\n        }\n        userLabel\n      }\n    }\n  }\n}\n\nfragment EventForm_viewer on Viewer {\n  remainingMeetingRecordingCredits\n  account {\n    name\n    id\n  }\n  user {\n    id\n    firstName\n  }\n  autoRecordSettings {\n    enabled\n    meetingOwnershipFilter\n    id\n  }\n  calendars {\n    edges {\n      node {\n        id\n        source\n        sourcePrimary\n        syncEnabled\n        name\n        color\n        lastSyncDatetime\n        hadErrorOnSync\n      }\n    }\n  }\n  ...useConferencingOptions_viewer\n  ...useParticipantsOptions_viewer\n  ...usePreferredTimezone_viewer\n  ...RecordingRowOutOfCreditsWarning_viewer\n}\n\nfragment MeetingsPanelHeader_viewer on Viewer {\n  uxSimplificationEnabled\n  ...MeetingsPanelMenu_viewer\n  ...DatePickerAgenda_viewer\n}\n\nfragment MeetingsPanelMenu_viewer on Viewer {\n  uxSimplificationEnabled\n  ...EventFilters_viewer\n}\n\nfragment MeetingsPanel_viewer on Viewer {\n  uxSimplificationEnabled\n  calendarServiceToReconnect\n  dismissedElements {\n    id\n    key\n  }\n  hasAccessToCopilot\n  calendars {\n    edges {\n      node {\n        id\n        source\n        sourcePrimary\n        syncEnabled\n        name\n        color\n        lastSyncDatetime\n        hadErrorOnSync\n      }\n    }\n  }\n  ...EventFormModal_viewer\n  ...MeetingsPanelHeader_viewer\n}\n\nfragment RecordingRowOutOfCreditsWarning_viewer on Viewer {\n  hasAdminAccess\n  account {\n    primaryAdmin {\n      fullName\n      id\n    }\n    recordingCredits {\n      includedAiMeetingCredits\n      id\n    }\n    billingAccount {\n      isSubscriptionActive\n      subscriptionState\n      subscriptionBillingCycleAnchor\n      id\n    }\n    id\n  }\n}\n\nfragment WeekPreview_viewer on Viewer {\n  ...usePreferredTimezone_viewer\n  settings {\n    timezonePreferences {\n      preferredTimezone {\n        userLabel\n        timezone {\n          name\n        }\n      }\n      extraTimezones {\n        userLabel\n        timezone {\n          name\n        }\n      }\n    }\n  }\n}\n\nfragment useConferencingOptions_viewer on Viewer {\n  id\n  defaultConferenceProvider\n  user {\n    id\n  }\n  integrations {\n    zoom {\n      id\n      hasMeetingWriteScope\n    }\n  }\n  calendars {\n    edges {\n      node {\n        id\n        source\n      }\n    }\n  }\n}\n\nfragment useParticipantsOptions_viewer on Viewer {\n  account {\n    isPersonalType\n    emailDomainList\n    id\n  }\n}\n\nfragment usePreferredTimezone_viewer on Viewer {\n  settings {\n    timezonePreferences {\n      preferredTimezone {\n        timezone {\n          name\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b5b6464093e2ad40af7dcb7c5eb4566";

export default node;
